import { useEffect, useState } from "react";
import { Sparkles, Flame } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

// Parent view of the smart classroom: skill stage, level, streak, labs and a plain-language summary per linked child.
export const ParentSmart = ({ creds }) => {
  const { L } = useLang();
  const [d, setD] = useState(null);
  useEffect(() => { api.post("/progress/smart", creds).then((r) => setD(r.data.children)).catch(() => setD([])); }, [creds]);
  if (!d?.length) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5" data-testid="parent-smart">
      <h3 className="font-bold text-[#0A192F] flex items-center gap-2"><Sparkles className="w-5 h-5 text-[#FF2E63]" />{L("Smart classroom progress", "स्मार्ट क्लासरूम प्रगति")}</h3>
      {d.map((c, i) => (
        <div key={i} className="mt-4 rounded-2xl bg-[#F0F4F8] p-4" data-testid={`parent-smart-child-${i}`}>
          <div className="flex flex-wrap items-center gap-2 text-sm font-bold text-[#0A192F]">{c.student_name}
            <span className="px-2 py-0.5 rounded-full bg-[#0A192F] text-white text-[11px]">{L(c.stage, c.stage_hi)} · {c.xp} XP</span>
            {c.streak > 0 && <span className="px-2 py-0.5 rounded-full bg-[#FFF3D6] text-[#7A4A00] text-[11px] inline-flex items-center gap-1"><Flame className="w-3 h-3" />{L(`${c.streak}-day streak`, `${c.streak} दिन लगातार`)}</span>}
          </div>
          <p className="mt-2 text-sm text-slate-600" data-testid={`parent-smart-summary-${i}`}>{L(c.summary, c.summary_hi)}</p>
          <div className="mt-2 text-xs text-slate-500">{L(`Robotics ${c.tracks.robotics}% · Drones ${c.tracks.drones}% · AI ${c.tracks.ai}% · Portfolio items ${c.portfolio.length}`,
            `रोबोटिक्स ${c.tracks.robotics}% · ड्रोन ${c.tracks.drones}% · AI ${c.tracks.ai}% · पोर्टफ़ोलियो ${c.portfolio.length}`)}</div>
        </div>
      ))}
    </div>
  );
};
